
const state2abbreviationMapping = {
  'Arizona': 'AZ',
  'Alabama': 'AL',
  'Alaska': 'AK',
  'American Samoa': 'AS',
  'Arkansas': 'AR',
  'California': 'CA',
  'Colorado': 'CO',
  'Connecticut': 'CT',
  'Delaware': 'DE',
  'District Of Columbia': 'DC',
  'Florida': 'FL',
  'Georgia': 'GA',
  'Guam': 'GU',
  'Hawaii': 'HI',
  'Idaho': 'ID',
  'Illinois': 'IL',
  'Indiana': 'IN',
  'Iowa': 'IA',
  'Northern Mariana Islands': 'IS',
  'Kansas': 'KS',
  'Kentucky': 'KY',
  'Louisiana': 'LA',
  'Maine': 'ME',
  'Maryland': 'MD',
  'Massachusetts': 'MA',
  'Michigan': 'MI',
  'Minnesota': 'MN',
  'Mississippi': 'MS',
  'Missouri': 'MO',
  'Montana': 'MT',
  'Nebraska': 'NE',
  'Nevada': 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  'Ohio': 'OH',
  'Oklahoma': 'OK',
  'Oregon': 'OR',
  'Pennsylvania': 'PA',
  'Puerto Rico': 'PR',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  'Tennessee': 'TN',
  'Texas': 'TX',
  'Utah': 'UT',
  'Vermont': 'VT',
  'Virginia': 'VA',
  'Virgin Islands': 'VI',
  'Washington': 'WA',
  'West Virginia': 'WV',
  'Wisconsin': 'WI',
  'Wyoming': 'WY',
} as any;

export default Object.keys(state2abbreviationMapping).map(o => ({key: o, text: o, value: o}));
export const state2abbreviation = (state: any) => {
  return state2abbreviationMapping[state];
};

const specialCircumstances = {
  'Colorado': true,
  'Connecticut': true,
  'District Of Columbia': true,
  'Hawaii': true,
  'Illinois': true,
  'Maine': true,
  'Maryland': true,
  'Massachusetts': true,
  'Minnesota': true,
  'New Jersey': true,
  'New York': true,
  'Oregon': true,
} as any;
export const specialCircumstancesForState = (state: any) => {
  return specialCircumstances[state];
};
